import { render, staticRenderFns } from "./order_details.vue?vue&type=template&id=47382828&scoped=true&"
import script from "./order_details.vue?vue&type=script&lang=js&"
export * from "./order_details.vue?vue&type=script&lang=js&"
import style0 from "./order_details.vue?vue&type=style&index=0&id=47382828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47382828",
  null
  
)

export default component.exports